import { getVoiceReportingTextAnalysisDetails } from '@op/services/voiceReportingTextAnalysis';
import {
  formatFilterTime,
  formatTime,
  languageRenderHelper,
} from '../renderHelper';
import { DownloadConfigInfoType } from '../types';

import {
  IIntentOptions,
  transIntent,
} from '@op/pages/report/VoiceReportingTextAnalysis';

export const VoiceReportingTextAnalysisChart: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const { dateType, columnsConfig } = auxiliaryParams;

    const renderTime = formatFilterTime({ date_type: dateType });

    const tableColumns: any = [
      {
        key: 'time',
        header: 'Date',
        fixed: 'left',
        renderHelper: [renderTime],
      },
      ...columnsConfig.map((val: { key: any; name: any }) => ({
        key: val.key,
        header: val.name,
      })),
    ];

    return tableColumns;
  },
};

function transIntentRenderHelper(intentOptions: IIntentOptions[]) {
  return (item: { [key: string]: any }, key: string) =>
    transIntent(intentOptions, item[key]);
}

export const VoiceReportingTextAnalysisTable: DownloadConfigInfoType = {
  type: 'page',
  valueKey: 'detail_list',
  totalKey: 'total',
  columns: ({ filter, auxiliaryParams }) => {
    const { intentOptions } = auxiliaryParams;

    const tableColumns: any = [
      {
        header: 'Date',
        key: 'time',
        renderHelper: [formatTime(filter)],
      },
      {
        header: 'Report Text',
        key: 'text',
      },
      {
        header: 'Report Text in English',
        key: 'text_en',
      },
      {
        header: 'Report Text in Chinese',
        key: 'text_zh',
      },
      {
        header: 'Create Time',
        key: 'create_time',
      },
      {
        header: 'Report Time',
        key: 'report_time',
      },
      {
        header: 'Language',
        key: 'language',
        renderHelper: [languageRenderHelper],
      },
      {
        header: 'Intent',
        key: 'intent',
        renderHelper: [transIntentRenderHelper(intentOptions)],
      },
      {
        header: 'Battleid',
        key: 'battle_id',
      },
      {
        header: 'Reportopenid',
        key: 'report_open_id',
      },
      {
        header: 'Mode',
        key: 'mode',
      },
      {
        header: 'ID',
        key: 'id',
      },
    ];

    return tableColumns;
  },
  downloadFunc: getVoiceReportingTextAnalysisDetails,
};
